document.addEventListener("DOMContentLoaded", (event) => {
document.querySelectorAll('.site-nav--is-megamenu').forEach(dropdown => {
    const megaMenu = dropdown.querySelector('.megamenu');
    let hideTimeout;

    // Show the menu with dynamic height
    const showMenu = () => {
      clearTimeout(hideTimeout);
      megaMenu.style.display = 'block';
      const fullHeight = megaMenu.scrollHeight;

      gsap.to(megaMenu, {
        height: fullHeight,
        opacity: 1,
        duration: 0.3,
        ease: 'power2.out',
        onStart: () => {
          megaMenu.style.pointerEvents = 'auto';
        }
      });
    };

    // Hide the menu smoothly
    const hideMenu = () => {
      hideTimeout = setTimeout(() => {
        gsap.to(megaMenu, {
          height: 0,
          opacity: 0,
          duration: 0.3,
          ease: 'power2.in',
          onComplete: () => {
            megaMenu.style.display = 'none';
            megaMenu.style.pointerEvents = 'none';
          }
        });
      }, 100); // short delay to prevent flicker
    };

    dropdown.addEventListener('mouseenter', showMenu);
    dropdown.addEventListener('mouseleave', hideMenu);
    megaMenu.addEventListener('mouseenter', () => clearTimeout(hideTimeout));
    megaMenu.addEventListener('mouseleave', hideMenu);
  });



//   document.querySelectorAll('.site-nav--is-megamenu').forEach(dropdown => {
//   const megaMenu = dropdown.querySelector('.megamenu');

//   dropdown.addEventListener('mouseenter', () => {
//     gsap.set(megaMenu, { height: 'auto', display: 'block' });
//     gsap.fromTo(megaMenu, 
//       { height: 0, opacity: 0 }, 
//       { 
//         height: megaMenu.scrollHeight, 
//         opacity: 1, 
//         duration: 0.4, 
//         ease: 'power2.out', 
//         overwrite: true 
//       });
//   });

//   dropdown.addEventListener('mouseleave', () => {
//     gsap.to(megaMenu, { 
//       height: 0, 
//       opacity: 0, 
//       duration: 0.3, 
//       ease: 'power2.in', 
//       onComplete: () => {
//         megaMenu.style.display = 'none';
//       }
//     });
//   });
// });
  
 

});
if ( $(window).width() < 767 ) {
	$(window).scroll(function() {
		if($("#default-button").length > 0)
		{
			var top_of_element = $("#default-button").offset().top;
			var bottom_of_element = $("#default-button").offset().top + $("#default-button").outerHeight();
			var bottom_of_screen = $(window).scrollTop() + $(window).innerHeight();
			var top_of_screen = $(window).scrollTop();
	
			if ( top_of_screen < bottom_of_element){
					// the element is visible, do something
					$("body").removeClass('show-sticky');
					// $("#default-button").show();
					$("#sticky-buttons").css('display','none');
					
			} else {
					$("body").addClass('show-sticky');
					// $("#default-button").hide();
					$("#sticky-buttons").css('display','block');
			}
		}
	}); 
};
$(document).on('click', '#sticky-buttons a', function(){
	$('html, body').stop().animate({
			scrollTop: $('#default-button').offset().top - 350
	}, 600 );
});
$(document).on('click', '#review-link', function(){
	$('html, body').stop().animate({
			scrollTop: $('#looxReviews').offset().top - 20
	}, 600 );
});
$(document).on('click', '#faq-link', function(){
	$('html, body').stop().animate({
			scrollTop: $('#faq').offset().top - 20
	}, 600 );
});
$(document).on('click', 'body.christmas-page .promo-grid .promo-grid__content a', function(event){
  event.preventDefault();
	$('html, body').stop().animate({
			scrollTop: $('[data-section-type="product"]').offset().top - 20
	}, 600 );
});
$(document).ready(function() {

		var newViewportWidth = $(window).width();
		if (newViewportWidth < 768) {
			$(window).scroll(function() {
	
				if ($(this).scrollTop() > 1130) {
				  
				  $('.sticky__addTo-wrapp').fadeIn();
				} else {
				  
				  $('.sticky__addTo-wrapp').fadeOut();
				}
			  });
		}
});



// money-back-popup
$(document).on('click', '#money-back-btn', function() {
    $(".money-back-popup").fadeIn('slow');
    $("body").addClass('bg-overlay-popup');
    $(".bg-overlay").addClass('active');
});

function closePopup() {
    $(".money-back-popup").fadeOut('slow');
    $("body").removeClass('bg-overlay-popup');
    $(".bg-overlay").removeClass('active');
}

// Close the popup when clicking on specific elements
$(document).on('click', '.money-back-top, .bg-overlay', function() {
    closePopup();
});




// $(document).on("click", ".js-qty__adjust--minus", function() {
	
// 			fetch("?section_id=main-cart")
// 			  .then((res) => res.text())
// 			  .then((data) => {
// 				var cart__html = $(data);
// 				var render__html = $(".cart__checkout-wrapper", cart__html);
// 				$(".cart__checkout-wrapper").replaceWith(render__html);
		  
// 			  });
		  
		  
	  
// });


// Announcement bar countdown timer code start 
  document.addEventListener("DOMContentLoaded", function () {
    const timers = document.querySelectorAll('.announcement-timer');
    if (!timers.length) return;

    timers.forEach(timerEl => {
      function parseCustomDate(str) {
        const parts = str.split(':');
        const date = parts[0];
        const time = parts.slice(1).join(':');
        return new Date(`${date}T${time}`);
      }

      const start = parseCustomDate(timerEl.dataset.start);
      const end = parseCustomDate(timerEl.dataset.end);
      const now = new Date();

      if (now < start || now > end) {
        timerEl.style.display = 'none';
        return;
      }

      const countdownEl = timerEl.querySelector('.announcement-timer-text');

      function updateCountdown() {
        const now = new Date();
        const diff = end - now;

        if (diff <= 0) {
          timerEl.style.display = 'none';
          clearInterval(interval);
          return;
        }

        const days = Math.floor(diff / (1000 * 60 * 60 * 24));
        const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
        const minutes = Math.floor((diff / (1000 * 60)) % 60);
        const seconds = Math.floor((diff / 1000) % 60);

        countdownEl.textContent = `: ${days}d ${hours}h ${minutes}m ${seconds}s`;
      }

      updateCountdown();
      const interval = setInterval(updateCountdown, 1000);
    });
  });
// Announcement bar countdown timer code end 